<template>
  <ThemeProvider :color="themeColor">
    <div class="inner-wrapper">
      <nuxt />
    </div>
    <sh-footer tabindex="-1"/>
  </ThemeProvider>
</template>

<script>
import { ThemeProvider } from '@sohohouse/design-system'

import ShFooter from '~/components/sh-footer'
import Theme from '../constants/theme'

export default {
  middleware: [
    'applicationForm',
    'hasVerifiedAccount'
  ],

  components: {
    ShFooter,
    ThemeProvider
  },

  computed: {
    themeColor () {
      return Theme.Light
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
